module.exports = "pegasus_template/assets/lp/ebook/bg2.png";